import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	escalationRules: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.escalation-rules.no-translate',
		defaultMessage: 'Add escalation rules',
		description: 'Title of section seperator',
	},
	escalationRulesTooltip: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.escalation-rules-tooltip.no-translate',
		defaultMessage:
			'Set rules to notify responders when the specified time is over and alert status meets your conditions.',
		description: 'Tooltip text of escalation rules seperator',
	},
	addRule: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.add-rule.no-translate',
		defaultMessage: 'Add rule',
		description: 'Label of add escalation rule button',
	},
	lastRule: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.last-rule.no-translate',
		defaultMessage: 'You can add only up to 50 rules. This is the last one.',
		description: 'Warning message that shown when user adding 49th method',
	},
	ruleLimit: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.rule-limit.no-translate',
		defaultMessage:
			'This policy has a maximum limit of 50 escalation rules. To add a new rule, delete one or more existing rules.',
		description: 'Warning message that shown when user added 50 method',
	},
	isProcessing: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.is-processing.no-translate',
		defaultMessage: 'Save escalation rules before you continue.',
		description:
			'Error shown when user tries to save escalation policy without confirming escalation rules.',
	},
});

export default messages;
